import { render } from "./blog-categories-table.vue?vue&type=template&id=c49383fe"
import script from "./blog-categories-table.vue?vue&type=script&lang=js"
export * from "./blog-categories-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__